
// Namespacing

window.site = (window.site || {});


// ScrollAnimation - opened / close

site.ScrollAnimation = (function ScrollAnimation($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

    /**
     * Initializes the class.
     * @public
     */
    var init = function() {

      // Abort if already initialized
      if (inited) {
        return false;
      }

      inited = true;

      // Initiate SidePanel
      initAnimation();

      return true;

    };

    // ------------------------------------
    // EVENT HANDLERS
    // ------------------------------------

    var initAnimation = function() {

      new WOW({
        offset: 20,
        mobile : false
      }).init();

    };

    return {
      init: init
    };

}.bind(site, jQuery)());

